"use client";

import CatalogBookCard from "@components/CatalogBookCard/CatalogBookCard";
import Entity from "@components/Entity";
import Meta from "@components/Meta";
import Pagination from "@components/Pagination/Pagination";
import { useAppContext } from "@components/Provider";
import { _isFirstPage, _isLastPage, getBasePageLink, getLastPageNumber, getPageNumberAsInt, getPaginationText, nextLink, previousLink, startCase } from "helpers/Helper";

import styles from "./Publisher.module.css";

const populateSEO = (title) => {
  let SEO_Data = {
    Title: startCase(`${title}`),
    Description: '',
  };
  return SEO_Data;
};

const Publisher = (props) => {
  const { data, router, isMobile, siteId, subscriberCookie } = useAppContext();
  const { SiteSettings } = data || {};
  const siteName = SiteSettings.site_name;
  const slugName = props.slug ? decodeURIComponent(props.slug) : '';
  const pageSize = props.pageSize;
  const books = props.books;
  const totalBooks = props.totalBooks;
  const host = props.host;
  const currentPageNumber = getPageNumberAsInt(props.pageNumber);
  const isFirstPage = _isFirstPage(currentPageNumber);
  const isLastPage = _isLastPage(currentPageNumber, totalBooks, pageSize);
  const publisherName = totalBooks > 1 ? `${slugName} (${totalBooks} Books)` : `${slugName} (${totalBooks} Book)`;
  const route = router.asPath;

  return (
    <>
      <Meta
        url={props.pageUrl}
        static={populateSEO(`Publisher | ${siteName}`)}
        pageType={Entity.STATIC}
        siteName={siteName}
        domain={host}
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
        previousLink={previousLink(props.pageName, slugName, currentPageNumber)}
        nextLink={nextLink(props.pageName, slugName, currentPageNumber)}
        isNewAppRouter={true}
      />
      <div
        className={
          isMobile ? 
            ["bookCardContainer", styles.publisherSection, "topPadding"].join(" ") : 
            ["bookCardContainer", styles.publisherSection].join(" ")
        }
      >
        <h1 className="mainHeading" dangerouslySetInnerHTML={{ __html: publisherName }} />
        <div className="booksCard">
          <CatalogBookCard
            Books={books}
            AffiliateCode={SiteSettings.preview_link_affiliate_code}
            SiteId={siteId}
            host={host}
            ShowContributor={true}
            TotalBooks={totalBooks}
            RenderSchema={true}
            ShowFollowAuthor={true}
            EventName="clickFollow-PublisherPage"
            ShouldLazyLoadCount={8}
            subscriberCookie={subscriberCookie}
          />
        </div>
        <Pagination
          isFirstPage={isFirstPage}
          isLastPage={isLastPage}
          basePageLink={getBasePageLink(props.pageName, slugName)}
          currentPageNumber={currentPageNumber}
          lastPageNumber={getLastPageNumber(totalBooks, pageSize)}
          getLinkHref={route}
          paginationText={getPaginationText(totalBooks, currentPageNumber, pageSize, 'eBooks')}
          pageSize={pageSize}
        />
      </div>
    </>
  )
}

export default Publisher;